module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAlklEQVQ4T2NkoBAwUqifgXYGzF26vp6BkeFKclTgWnyuxOmCuYvW2TAwMWxmYGJMwWcIXi8QYwjBMCBkCEEDQP6HGfKfgTEkJSZwL3KYEGXAnCVrrRkZGNYw/PvvmxwXcoYkAxCaGUOT44KOoMcIXhcQ0gwyDKcBxGjGb8DSdeWMfxmOYnM2SWFAKK8QFQtkJWVCNsPkAcLVORFM8ISVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/05.png
// module id = 6Aki
// module chunks = 1